import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/avatar.jpg'


const _withScopeId = n => (_pushScopeId("data-v-1f307e13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspectors list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No inspectors found", -1))
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "7%" }),
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Mobile"),
  /*#__PURE__*/_createElementVNode("th", null, "Email"),
  /*#__PURE__*/_createElementVNode("th", { width: "7%" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: _imports_0,
  class: "avatar"
}
const _hoisted_11 = { class: "align-middle" }
const _hoisted_12 = { class: "align-middle" }
const _hoisted_13 = { class: "align-middle" }
const _hoisted_14 = { class: "align-middle text-right" }
const _hoisted_15 = { class: "list-unstyled mb-0" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import { Inspector } from '@/models';

// Injected properties

export default /*#__PURE__*/_defineComponent({
  __name: 'InspectorsList',
  setup(__props) {

const actProperty: any = inject('actProperty');
const store = useStore();
const router = useRouter();
const route = useRoute();
const toasted = useToast();

// Vuex getters and actions
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const inspectors = computed(() => store.getters['inspectors/list']);

const deleteInspector = async (inspector: Inspector) => {
  await store.dispatch('inspectors/deleteInspector', inspector);
};

// Methods
const edit = (inspector: Inspector) => {
  if (inspector.hasOwnProperty("id")) {
    router.push({ name: 'inspector', params: { id: inspector.id } });
  } else {
    actProperty.displayError("Error");
  }
};

const remove = async (inspector: Inspector) => {
  actProperty
    .confirmPrompt()
    .then(() => deleteInspector(inspector))
    .then(() => toasted.success("Inspector deleted"))
    .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!inspectors.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" beginning with “"),
            _createElementVNode("strong", null, _toDisplayString((_unref(route).params.search as string).toUpperCase()), 1),
            _createTextVNode("” ")
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspectors.value, (inspector) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: inspector.id,
                onClick: ($event: any) => (edit(inspector))
              }, [
                _createElementVNode("td", _hoisted_8, [
                  (
                inspector.picture &&
                inspector.picture.length &&
                inspector.picture[0].src
              )
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(actProperty).s3Origin(inspector.picture[0].src),
                        class: "avatar"
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", _hoisted_10))
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(inspector.name), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(inspector.mobile), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(inspector.email), 1),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", {
                      class: "list-item",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (remove(inspector))
                      }, _hoisted_18, 8, _hoisted_16)
                    ])
                  ])
                ])
              ], 8, _hoisted_7))
            }), 128))
          ])
        ]))
  ]))
}
}

})